// src/components/BrandBrowseSection.jsx
import React, { useRef, useState, useMemo } from "react";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useFilters } from "../../stores/useFilters"; // adjust path as needed
import { LOGO_URL_MAP } from "../../data/brandLogos";

export default function BrandBrowseSection({ makes = [] }) {
  const scrollRef = useRef(null);
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate();
  const { set, reset } = useFilters();

  // 1) Build a lower-case key → logo URL map once
  const normalizedLogoMap = useMemo(() => {
    const map = {};
    Object.entries(LOGO_URL_MAP).forEach(([brandName, url]) => {
      map[brandName.toLowerCase()] = url;
    });
    return map;
  }, []);

  // const scroll = (direction) => {
  //   if (!scrollRef.current) return;
  //   scrollRef.current.scrollBy({
  //     left: direction === "left" ? -300 : 300,
  //     behavior: "smooth",
  //   });
  // };

  const handleBrandClick = (make) => {
    reset();
    set("make", make);
    navigate("/used-cars");
  };

  // 2) Map the incoming makes, doing a case-insensitive lookup for the logo
  const filteredMakes = useMemo(
    () =>
      makes.map(({ value, count }) => {
        const makeKey = value.toLowerCase();
        const logo = normalizedLogoMap[makeKey]; // will be undefined if not found
        return { name: value, count, logo };
      }),
    [makes, normalizedLogoMap]
  );

  // 3) Determine top 4 brands by count
  const topMakes = useMemo(() => {
    return [...filteredMakes].sort((a, b) => b.count - a.count).slice(0, 4);
  }, [filteredMakes]);

  // 4) Group by first letter for the "all brands" section
  const groupedBrands = useMemo(
    () =>
      filteredMakes.reduce((acc, brand) => {
        const letter = brand.name.charAt(0).toUpperCase();
        if (!acc[letter]) acc[letter] = [];
        acc[letter].push(brand);
        return acc;
      }, {}),
    [filteredMakes]
  );

  console.log(groupedBrands);

  return (
    <div className="bg-white text-primary py-10">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-red-500 text-center pb-8">
        Browse by brand
      </h2>

      {/* Carousel section: only top 4 brands */}
      <section className="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={scrollRef}
          className="flex flex-wrap justify-center overflow-x-auto hide-scrollbar gap-4 px-4 sm:px-6"
        >
          {topMakes.map((brand, idx) => (
            <div
              key={idx}
              onClick={() => handleBrandClick(brand.name)}
              className="flex-shrink-0 w-full sm:w-48 md:w-56 lg:w-64 h-60 bg-white border border-gray rounded-xl p-4 hover:shadow-md transition cursor-pointer"
            >
              <div className="w-20 h-20 mx-auto">
                {brand.logo ? (
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="w-full h-full object-contain"
                  />
                ) : (
                  <div className="w-full h-full bg-gray-200 rounded-full" />
                )}
              </div>
              <div className="text-center mt-10">
                <p className="text-primary font-bold">{brand.name}</p>
                <p className="text-sm text-gray-700 mt-1">
                  View {brand.count.toLocaleString()} cars
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* “View all” toggle */}
      {filteredMakes.length > 4 && (
        <div className="text-center mt-8">
          <button
            onClick={() => setShowAll((s) => !s)}
            className="text-primary font-medium hover:underline"
          >
            {showAll ? "Hide all brands ▲" : "View all brands →"}
          </button>
        </div>
      )}

      {/* Full list, grouped by letter */}
      {showAll && (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 pt-12">
          {Object.keys(groupedBrands)
            .sort()
            .map((letter) => (
              <div key={letter} className="mb-10">
                <h3 className="text-xl font-bold mb-4 text-[#1c2553]">
                  {letter}
                </h3>
                <div className="flex flex-wrap gap-5">
                  {groupedBrands[letter].map((brand, i) => (
                    <button
                      key={i}
                      onClick={() => handleBrandClick(brand.name)}
                      className="inline-flex items-center gap-3 px-4 py-2 bg-white border text-base font-bold rounded hover:shadow-md transition whitespace-nowrap"
                    >
                      <div className="w-10 h-5">
                        {brand.logo ? (
                          <img
                            src={brand.logo}
                            alt={brand.name}
                            className="w-full h-full object-contain"
                          />
                        ) : (
                          <div className="w-full h-full bg-gray-200 rounded-full" />
                        )}
                      </div>
                      <span className="text-primary">{brand.name}</span>
                    </button>
                  ))}
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}

// // src/components/BrandBrowseSection.jsx
// import React, { useRef, useState, useMemo } from "react";
// // import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { useFilters } from "../../stores/useFilters"; // adjust path as needed
// import { LOGO_URL_MAP } from "../../data/brandLogos";

// export default function BrandBrowseSection({ makes = [] }) {
//   const scrollRef = useRef(null);
//   const [showAll, setShowAll] = useState(false);
//   const navigate = useNavigate();
//   const { set, reset } = useFilters();

//   // 1) Build a lower-case key → logo URL map once
//   const normalizedLogoMap = useMemo(() => {
//     const map = {};
//     Object.entries(LOGO_URL_MAP).forEach(([brandName, url]) => {
//       map[brandName.toLowerCase()] = url;
//     });
//     return map;
//   }, []);

//   const scroll = (direction) => {
//     if (!scrollRef.current) return;
//     scrollRef.current.scrollBy({
//       left: direction === "left" ? -300 : 300,
//       behavior: "smooth",
//     });
//   };

//   const handleBrandClick = (make) => {
//     reset();
//     set("make", make);
//     navigate("/used-cars");
//   };

//   // 2) Map the incoming makes, doing a case-insensitive lookup for the logo
//   const filteredMakes = useMemo(
//     () =>
//       makes.map(({ value, count }) => {
//         const makeKey = value.toLowerCase();
//         const logo = normalizedLogoMap[makeKey]; // will be undefined if not found
//         return { name: value, count, logo };
//       }),
//     [makes, normalizedLogoMap]
//   );

//   // 3) Group by first letter (unchanged)
//   const groupedBrands = useMemo(
//     () =>
//       filteredMakes.reduce((acc, brand) => {
//         const letter = brand.name.charAt(0).toUpperCase();
//         if (!acc[letter]) acc[letter] = [];
//         acc[letter].push(brand);
//         return acc;
//       }, {}),
//     [filteredMakes]
//   );

//   return (
//     <div className="bg-white text-primary py-12 sm:py-16 lg:py-24">
//       <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-red-500 text-center pb-8">
//         Browse by brand
//       </h2>

//       {/* Carousel section (unchanged, but using filteredMakes) */}
//       <section className="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div
//           ref={scrollRef}
//           className="flex flex-wrap justify-center overflow-x-auto hide-scrollbar gap-4 px-4 sm:px-6"
//         >
//           {filteredMakes.map((brand, idx) => (
//             <div
//               key={idx}
//               onClick={() => handleBrandClick(brand.name)}
//               className="flex-shrink-0 w-full sm:w-48 md:w-56 lg:w-64 h-60 bg-white border border-gray rounded-xl p-4 hover:shadow-md transition cursor-pointer"
//             >
//               <div className="w-20 h-20 mx-auto">
//                 {brand.logo ? (
//                   <img
//                     src={brand.logo}
//                     alt={brand.name}
//                     className="w-full h-full object-contain"
//                   />
//                 ) : (
//                   <div className="w-full h-full bg-gray-200 rounded-full" />
//                 )}
//               </div>
//               <div className="text-center mt-10">
//                 <p className="text-primary font-bold">{brand.name}</p>
//                 <p className="text-sm text-gray-700 mt-1">
//                   View {brand.count.toLocaleString()} cars
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* “View all” toggle */}
//       {filteredMakes.length > 4 && (
//         <div className="text-center mt-8">
//           <button
//             onClick={() => setShowAll((s) => !s)}
//             className="text-primary font-medium hover:underline"
//           >
//             {showAll ? "Hide all brands ▲" : "View all brands →"}
//           </button>
//         </div>
//       )}

//       {/* Full list, grouped by letter */}
//       {showAll && (
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-20 pt-12">
//           {Object.keys(groupedBrands)
//             .sort()
//             .map((letter) => (
//               <div key={letter} className="mb-10">
//                 <h3 className="text-xl font-bold mb-4 text-[#1c2553]">
//                   {letter}
//                 </h3>
//                 <div className="flex flex-wrap gap-5">
//                   {groupedBrands[letter].map((brand, i) => (
//                     <button
//                       key={i}
//                       onClick={() => handleBrandClick(brand.name)}
//                       className="inline-flex items-center gap-3 px-4 py-2 bg-white border text-base font-bold rounded hover:shadow-md transition whitespace-nowrap"
//                     >
//                       <div className="w-10 h-5">
//                         {brand.logo ? (
//                           <img
//                             src={brand.logo}
//                             alt={brand.name}
//                             className="w-full h-full object-contain"
//                           />
//                         ) : (
//                           <div className="w-full h-full bg-gray-200 rounded-full" />
//                         )}
//                       </div>
//                       <span className="text-primary">{brand.name}</span>
//                     </button>
//                   ))}
//                 </div>
//               </div>
//             ))}
//         </div>
//       )}
//     </div>
//   );
// }
